import React from "react";

import { updatePassword } from "../../model/profile";

import { commonErr } from "../common/errors";
import { CustomInputLabelOutside } from "../components/input";
import { MessageBox } from "../common/messagebox";

import Header from "../components/header";
import Footer from "../components/footer";
import Session from "../common/session";
import AccountSideBar from "../account/components/accountsidebar";

import { IcPassword, IcEye } from "../common/svg";

export default class ResetPw extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			ip_pw: "",
			ip_reset_pw: "",
			ip_reset_pw_confirm: "",
			ipTypePw: "password",
			ipTypeReset: "password",
			ipTypeResetPw: "password",
			showMessageBox: false,
		};
	}

	componentDidMount() {
		window.scrollTo(0, 0);
	}

	handleInputChange = (event) => {
		this.setState({
			[event.target.name]: event.target.value,
		});
	};

	retry = () => {
		this.setState({
			err: commonErr.INNIT,
			errMsg: "",
			ip_pw: "",
			ip_reset_pw: "",
			ip_reset_pw_confirm: "",
		});
	};

	onResetPwBtnClick = () => {
		const { ip_pw, ip_reset_pw, ip_reset_pw_confirm } = this.state;

		if (ip_pw !== "" && ip_reset_pw !== "") {
			if (ip_reset_pw === ip_reset_pw_confirm) {
				updatePassword(ip_pw, ip_reset_pw).then((resp) => {
					if (resp?.data?.error === commonErr.SUCCESS) {
						this.setState({
							err: resp.data.error,
							errMsg: "Mật khẩu đã được làm mới thành công",
							showMessageBox: true,
						});
					} else {
						this.setState({
							err: resp.data.error,
							errMsg: resp.data.errorMessage,
							showMessageBox: true,
						});
					}
				});
			} else {
				this.setState({
					err: commonErr.FAIL,
					errMsg: "Mật khẩu mới không khớp.",
					showMessageBox: true,
				});
			}
		}
	};

	toggleInput = (name, str) => {
		this.setState({
			[`${name}`]: str,
		});
	};

	renderPw = (name, type) => {
		const ipType = type === "password" ? "text" : "password";

		return (
			<div className="wrap-svg" onClick={() => this.toggleInput(name, ipType)}>
				{type === "password" ? <IcPassword /> : <IcEye />}
			</div>
		);
	};

	showMessageBox = () => {
		this.setState({
			showMessageBox: true,
		});
	};

	hideMessageBox = () => {
		this.setState({
			showMessageBox: false,
		});
	};

	render() {
		const {
			err,
			errMsg,
			showMessageBox,
			ipTypePw,
			ipTypeReset,
			ipTypeResetPw,
			ip_pw,
			ip_reset_pw,
			ip_reset_pw_confirm,
		} = this.state;

		const icPw = this.renderPw("ipTypePw", ipTypePw);
		const icReset = this.renderPw("ipTypeReset", ipTypeReset);
		const icResetPw = this.renderPw("ipTypeResetPw", ipTypeResetPw);

		return (
			<div className="mioto-layout">
				<Session />
				<Header />
				<section className="body">
					<div className="account-section sec space">
						<div className="m-container">
							<div className="account-container">
								<AccountSideBar />
								<div className="content-account">
									<div className="content-title">
										<h4>Đổi mật khẩu</h4>
										<p>Vui lòng nhập mật khẩu hiện tại của bạn để thay đổi mật khẩu</p>
									</div>
									<div className="content-item change-pw">
										<div className="title">
											<h5>Nhập mật khẩu</h5>
										</div>
										<div className="content">
											<CustomInputLabelOutside
												type={ipTypePw}
												name={"ip_pw"}
												label="Mật khẩu hiện tại"
												onChange={this.handleInputChange}
												icRight={icPw}
											/>

											<CustomInputLabelOutside
												type={ipTypeReset}
												name={"ip_reset_pw"}
												label="Mật khẩu mới"
												onChange={this.handleInputChange}
												icRight={icReset}
											/>

											<CustomInputLabelOutside
												type={ipTypeResetPw}
												name={"ip_reset_pw_confirm"}
												label="Xác nhận mật khẩu mới"
												onChange={this.handleInputChange}
												icRight={icResetPw}
											/>

											<div className="apply-button">
												<a
													className="btn btn--m btn-primary"
													disabled={!ip_pw || !ip_reset_pw || !ip_reset_pw_confirm}
													onClick={this.onResetPwBtnClick}>
													Xác nhận
												</a>
											</div>
										</div>
										<MessageBox error={err} show={showMessageBox} hideModal={this.hideMessageBox} message={errMsg} />

										{/* 										
										<div className="line-form">
											<div className="wrap-input has-ico">
												<i className="ic ic-lock-fill"></i>
												<input type="password" placeholder="Mật khẩu mới" name="ip_reset_pw" onChange={this.handleInputChange} />
											</div>
										</div>
										<div className="line-form">
											<div className="wrap-input has-ico">
												<i className="ic ic-lock-fill"></i>
												<input type="password" placeholder="Lặp lại mật khẩu" name="ip_reset_pw_confirm" onChange={this.handleInputChange} />
											</div>
										</div>
								
										<button className="btn btn-primary btn--m" type="button" name="resetPw" onClick={this.onResetPwBtnClick.bind(this)}>Cập nhật mật khẩu</button> */}
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>

				<Footer />
			</div>
		);
	}
}

{
	/* <div className="content-item change-pw"> 
<div className="title"> 
  <h5>Nhập mật khẩu</h5>
</div>
<div className="content"> 
  <div className="custom-input">
	<div className="wrap-info">
	  <div className="title-status"> 
		<p>Mật khẩu hiện tại</p>
	  </div>
	</div>
	<div className="wrap-input"> 
	  <input type="password" />
	  <div className="wrap-svg"><svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		  <path d="M20.2 9.01006C21.6 10.7001 21.6 13.3001 20.2 14.9901C18.2 17.4001 15.27 18.9401 12 18.9401C8.73001 18.9401 5.81 17.4101 3.8 14.9901C2.4 13.3001 2.4 10.7001 3.8 9.01006C5.8 6.60006 8.73001 5.06006 12 5.06006C15.27 5.06006 18.19 6.59006 20.2 9.01006Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		  <path d="M20.2 9.01006C21.6 10.7001 21.6 13.3001 20.2 14.9901C18.2 17.4001 15.27 18.9401 12 18.9401C8.73001 18.9401 5.81 17.4101 3.8 14.9901C2.4 13.3001 2.4 10.7001 3.8 9.01006C5.8 6.60006 8.73001 5.06006 12 5.06006C15.27 5.06006 18.19 6.59006 20.2 9.01006Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		  <path d="M12 15.08C13.701 15.08 15.08 13.7011 15.08 12C15.08 10.299 13.701 8.92004 12 8.92004C10.299 8.92004 8.92001 10.299 8.92001 12C8.92001 13.7011 10.299 15.08 12 15.08Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	  </div>
	</div>
  </div>
  <div className="custom-input">
	<div className="wrap-info">
	  <div className="title-status"> 
		<p>Mật khẩu mới</p>
	  </div>
	</div>
	<div className="wrap-input"> 
	  <input type="password" />
	  <div className="wrap-svg"><svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		  <path d="M14.52 18.6301C13.71 18.8401 12.87 18.9401 12 18.9401C8.73 18.9401 5.8 17.4101 3.8 14.9901C2.4 13.3001 2.4 10.6901 3.8 9.01006C3.96 8.81006 4.14 8.62005 4.32 8.43005" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		  <path d="M20.2 14.9901C19.4 15.9501 18.45 16.7701 17.4 17.4101L6.59 6.59006C8.18 5.61006 10.02 5.06006 12 5.06006C15.27 5.06006 18.2 6.59006 20.2 9.01006C21.6 10.6901 21.6 13.3101 20.2 14.9901Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		  <path d="M15.08 12C15.08 12.85 14.73 13.62 14.18 14.18L9.82001 9.82005C10.37 9.26005 11.15 8.92004 12 8.92004C13.71 8.92004 15.08 10.29 15.08 12Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		  <path d="M2.75 2.75L6.59 6.59L9.82 9.82L14.18 14.18L17.41 17.41L21.25 21.25" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	  </div>
	</div>
  </div>
  <div className="custom-input">
	<div className="wrap-info">
	  <div className="title-status"> 
		<p>Xác nhận mật khẩu mới</p>
	  </div>
	</div>
	<div className="wrap-input"> 
	  <input type="password" />
	  <div className="wrap-svg"><svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		  <path d="M14.52 18.6301C13.71 18.8401 12.87 18.9401 12 18.9401C8.73 18.9401 5.8 17.4101 3.8 14.9901C2.4 13.3001 2.4 10.6901 3.8 9.01006C3.96 8.81006 4.14 8.62005 4.32 8.43005" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		  <path d="M20.2 14.9901C19.4 15.9501 18.45 16.7701 17.4 17.4101L6.59 6.59006C8.18 5.61006 10.02 5.06006 12 5.06006C15.27 5.06006 18.2 6.59006 20.2 9.01006C21.6 10.6901 21.6 13.3101 20.2 14.9901Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		  <path d="M15.08 12C15.08 12.85 14.73 13.62 14.18 14.18L9.82001 9.82005C10.37 9.26005 11.15 8.92004 12 8.92004C13.71 8.92004 15.08 10.29 15.08 12Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		  <path d="M2.75 2.75L6.59 6.59L9.82 9.82L14.18 14.18L17.41 17.41L21.25 21.25" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	  </div>
	</div>
  </div>
  <div className="apply-button"> <a className="btn btn-cancel">Hủy</a><a className="btn btn--m btn-primary">Xác nhận</a></div>
</div>
</div> */
}

// } else {
// 	content = <div className="form-default form-s">
// 		<div className="textAlign-center"><i className="ic ic-verify"></i> </div>
// 		<div className="clear"></div>
// 		<div className="space m"></div>
// 		<button className="btn btn-primary btn--m" type="button" name="resetPw" onClick={this.onFinishButtonClick.bind(this)}>Đăng nhập</button>
// 	</div>
// }
